import { LookDomType } from '@/types'
import { MessageType } from '@/utils/message'

// 初始化状态
const initState = {
  isHH: false,
  style: {},
  // 所有图片点击预览查看大图
  lookBigImg: {
    url: '',
    show: false,
    fromTxt: '',
    zoom: 1
  },
  // 查看视频、音频、模型
  lookDom: {
    src: '',
    type: ''
  } as LookDomType,

  // 查看PDF
  lookPdf: {
    url: '',
    show: false
  },

  // antd轻提示(兼容360浏览器)
  message: {
    txt: '',
    type: 'info',
    duration: 3
  } as MessageType,
  // 上传文件点击取消
  closeUpFile: {
    fu: () => {},
    state: false
  },
  // 总数据 - 中英文切换
  myData: {} as MyDataType,
  myLangue: 'ZH' as 'ZH' | 'EN',
  //unity是否被销毁,key变化的时候就要判断
  unityKey: 0,
  unityDel: false,
  // 后台管理配置的3个视频
  videos: {
    // 1:开场视频 2：融合之光  3：先导片
    1: '',
    2: '',
    3: ''
  }
}

// 定义 action 类型
type LayoutActionType =
  | { type: 'layout/isHH'; payload: boolean }
  | { type: 'layout/style'; payload: any }
  | {
      type: 'layout/lookBigImg'
      payload: { url: string; show: boolean; fromTxt: string; zoom: number }
    }
  | { type: 'layout/lookDom'; payload: LookDomType }
  // 查看PDF
  | { type: 'layout/lookPdf'; payload: { url: string; show: boolean } }
  | { type: 'layout/message'; payload: MessageType }
  | { type: 'layout/myData'; payload: MyDataType }
  | { type: 'layout/myLangue'; payload: 'ZH' | 'EN' }
  | { type: 'layout/unityKey'; payload: number }
  | { type: 'layout/unityDel'; payload: boolean }
  | { type: 'layout/videos'; payload: { 1: string; 2: string; 3: string } }
  | {
      type: 'layout/closeUpFile'
      payload: {
        fu: () => void
        state: boolean
      }
    }

// 频道 reducer
export default function layoutReducer(state = initState, action: LayoutActionType) {
  switch (action.type) {
    case 'layout/isHH':
      return { ...state, isHH: action.payload }
    case 'layout/style':
      return { ...state, style: action.payload }
    // 所有图片点击预览查看大图
    case 'layout/lookBigImg':
      return { ...state, lookBigImg: action.payload }
    // 查看视频
    case 'layout/lookDom':
      return { ...state, lookDom: action.payload }
    // 查看PDF
    case 'layout/lookPdf':
      return { ...state, lookPdf: action.payload }

    // antd轻提示(兼容360浏览器)
    case 'layout/message':
      return { ...state, message: action.payload }
    // 上传文件点击取消
    case 'layout/closeUpFile':
      return { ...state, closeUpFile: action.payload }
    // 中英文切换
    case 'layout/myData':
      return { ...state, myData: action.payload }
    case 'layout/myLangue':
      return { ...state, myLangue: action.payload }
    // unity是否被销毁，被销毁了为true
    case 'layout/unityKey':
      return { ...state, unityKey: action.payload }
    case 'layout/unityDel':
      return { ...state, unityDel: action.payload }
    // 后台管理配置的3个视频
    case 'layout/videos':
      return { ...state, videos: action.payload }

    default:
      return state
  }
}
